import React from 'react';
import Button from 'react-bootstrap/Button';
import { ButtonProps } from '@dreamai/types';

/**
 * Button component for our DSL
 */
export const ButtonComponent: React.FC<
  ButtonProps & { onClick?: (data: any) => void }
> = (props) => {
  const { value, variant, href, onClick, ...restProps } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick({
        event: e,
        element: e.currentTarget,
      });
    }
  };

  return (
    <Button
      variant={variant || 'primary'}
      onClick={handleClick}
      href={href}
      {...restProps}
    >
      {value}
    </Button>
  );
};

export default ButtonComponent;
